import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/css';
import { FilterTitle, FilterTitleMobile, sectionWrapper } from '../Ui';

const wrapperBtn = css`
  display: grid;
  margin: 5px 8px 0 0;
  grid-gap: 18px;
`;

const radioBtn = (params) => css`
  border: 0;
  padding: 0;
  outline: none;
  background: transparent;
  color: ${params?.textColor};
  font-size: 1.2em;
  display: flex;
  cursor: pointer;
  text-transform: capitalize;
  &:disabled {
    cursor: not-allowed;
    opacity: 0.4;
    text-decoration: none;
    pointer-events: none;
  }
`;

const circle = (params) => css`
  width: 20px;
  height: 20px;
  display: block;
  box-sizing: border-box;
  border-radius: 25px;
  border: 2px solid ${params?.textColor};
  ${params?.isRadioActive && (
    `background: ${params?.hoverBackgroundColor};`
  )}
  margin-right: 20px;
`;

const RadioBtnWidget = ({
  onChange,
  filter: {
    label,
    options,
    key: filterKey,
    activeValue,
  },
  themeConfig: {
    multiDropdown,
    bubbles,
  },
  isMobile,
}) => {
  const handleChangeValue = (val) => (e) => {
    onChange(filterKey, val === 'any' ? 'any' : val)(e);
  };
  return (
    <div className={sectionWrapper({ ...multiDropdown, isMobile, fitWidth: true })}>
      <div>
        {label && (isMobile
          ? (
            <FilterTitleMobile
              activeValueTotal={activeValue === 'any' ? 0 : 1}
              label={label}
              themeConfig={multiDropdown}
            />
          ) : (
            <FilterTitle label={label} themeConfig={multiDropdown} />
          )
        )}
        <div className={wrapperBtn}>
          <button
            type="button"
            onClick={handleChangeValue('any')}
            className={radioBtn(multiDropdown)}
          >
            <i className={circle({
              ...multiDropdown,
              hoverBackgroundColor: bubbles.hoverBackgroundColor,
              isRadioActive: activeValue === 'any',
            })}
            />
            All
          </button>
          {options?.map((o) => (
            <button
              type="button"
              onClick={handleChangeValue(o.value)}
              className={radioBtn(multiDropdown)}
              key={o.value}
            >
              <i className={circle({
                ...multiDropdown,
                hoverBackgroundColor: bubbles.hoverBackgroundColor,
                isRadioActive: activeValue === o.value,
              })}
              />
              {o.name}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

RadioBtnWidget.propTypes = {
  onChange: PropTypes.func,
  filter: PropTypes.object,
  themeConfig: PropTypes.object,
  isMobile: PropTypes.bool,
};

export default RadioBtnWidget;
